export class Validator {

     static setError(id){
        let pre = document.getElementById(id).style.border
        let doc = document.getElementById(id)
        doc.style.border='2px solid #f00'
        setTimeout(()=>{
            doc.style.border=pre
            //console.log('sadf')
        },1000)
    }
}